import { useCallback, useMemo, useState } from 'react';
import type { DishFormValues } from '../components/DishFormModal';
import type { Menu } from '../types';

export const useMenuModal = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [currentMenu, setCurrentMenu] = useState<Menu | null>(null);

  const showAddModal = useCallback(() => {
    setCurrentMenu(null);
    setModalVisible(true);
  }, []);

  const showEditModal = useCallback((record: Menu) => {
    setCurrentMenu(record);
    setModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  const initialFormValues = useMemo<
    DishFormValues | { tags: string[]; status: 'enabled' | 'disabled' }
  >(() => {
    if (currentMenu?.id) {
      return {
        name: currentMenu.name,
        description: currentMenu.description ?? undefined,
        pairing_id: currentMenu.pairing_id ?? undefined,
        price: currentMenu.price
          ? Number.parseFloat(currentMenu.price as string)
          : undefined,
        tags: currentMenu.tags ?? [],
        status: currentMenu.status as 'enabled' | 'disabled',
      };
    }
    return {
      tags: [],
      status: 'enabled',
    };
  }, [currentMenu]);

  return {
    modalVisible,
    currentMenu,
    initialFormValues,
    showAddModal,
    showEditModal,
    closeModal,
  };
};
